import { Stack } from "@mui/material"
import "./styles.scss"
import { TResourcePreview } from "./types"
import { Button, EmptyContent, FullBar, GenericWrapperContext, getBrandUrl, Icon, LoadingContainer, Modal, Typography } from "@cakemail-org/ui-components-v2"
import { useContext, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { updateIframe } from "../../../utils/components"
import { renderToString } from "react-dom/server"

export function ResourcePreview({ actions, content }: TResourcePreview) {
    const genericWrapper = useContext(GenericWrapperContext)
    const { t } = useTranslation()
    const [mobilePreview, setMobilePreview] = useState<boolean>(false)
    const [fullPreview, setFullPreview] = useState<boolean>(false)

    const emptyContent = renderToString(
        <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            boxSizing: 'border-box'
        }}>
            <EmptyContent />
        </div>
    )


    useEffect(() => {
        const iframe = document.querySelector(".resourcePreviewIframe") as HTMLIFrameElement
        updateIframe(iframe, content || emptyContent)
    }, [content])

    useEffect(() => {
        setTimeout(() => {
            const iframeFull = document.querySelector(".resourcePreviewIframeFull") as HTMLIFrameElement
            updateIframe(iframeFull, fullPreview ? content || emptyContent : undefined)
        }, 0)
    }, [fullPreview])

    function handlePreviewToggle() {
        setMobilePreview(!mobilePreview)
    }

    function handleTogglePreview() {
        setFullPreview(!fullPreview)
    }

    return <Stack className="resourcePreviewContainer">
        <FullBar
            className="resourcePreviewHeader"
            left={[
                <Button className={!mobilePreview ? "active" : ""} color="white" variant='contained' onClick={handlePreviewToggle} size="small" iconOnly >
                    <Icon name="Desktop18" />
                </Button>,
                <Button className={mobilePreview ? "active" : ""} color="white" variant='contained' onClick={handlePreviewToggle} size="small" iconOnly >
                    <Icon name="Mobile18" />
                </Button>,
                <Button color="white" variant='contained' onClick={handleTogglePreview} size="small" iconOnly >
                    {t("general-full-preview")}
                </Button>
            ]}
            right={actions}
        />
        <Stack className="resourcePreviewContent">
            <LoadingContainer loading={content === undefined}>
                <iframe className={`resourcePreviewIframe ${mobilePreview ? "mobile" : "desktop"}`} />
            </LoadingContainer>
        </Stack>

        <Modal
            open={fullPreview}
            className="resourcePreviewFullPreview"
            heading={{
                logoUrl: getBrandUrl({ brand: genericWrapper.partnerBrand, elKey: "logo" }),
                closeBtnText: t("general-close"),
                closeBtnOnClick: handleTogglePreview,
                actions: [
                    <Button className={!mobilePreview ? "active" : ""} color="shade100" variant='contained' onClick={handlePreviewToggle} iconOnly >
                        <Icon name="Desktop18" />
                    </Button>,
                    <Button className={mobilePreview ? "active" : ""} color="shade100" variant='contained' onClick={handlePreviewToggle} iconOnly >
                        <Icon name="Mobile18" />
                    </Button>
                ]
            }}
            content={<LoadingContainer loading={content === undefined}>
                <iframe className={`resourcePreviewIframeFull ${mobilePreview ? "mobile" : "desktop"}`} />
            </LoadingContainer>}
        />
    </Stack>
}